/* Downloads portal (guest ?code= links and logged-in customers). Loaded
   globally from theme.liquid (not from the section) because script tags
   inside SPA-swapped content never execute — the same reason od-resume-row.js
   is global. boot() derives its state from the DOM (an init flag on the
   section root), so it is safe to call repeatedly. */
(function () {
  "use strict";

  function boot() {
    var root = document.querySelector("[data-od-downloads-portal]");
    if (!root || root.dataset.odDlInit === "1") return;
    root.dataset.odDlInit = "1";

    var apiBase = (root.dataset.apiBase || "").replace(/\/$/, "");
    var portalEndpoint = root.dataset.portalEndpoint || "/apps/library/downloads";
    var loggedIn = root.dataset.loggedIn === "true";
    var contactUrl = root.dataset.contactUrl || "/pages/contact";
    var membershipUrl = root.dataset.membershipUrl || "/pages/membership";

    var statusEl = root.querySelector("[data-od-dl-status]");
    var ordersEl = root.querySelector("[data-od-dl-orders]");
    var emptyTemplate = root.querySelector("[data-od-dl-empty]");
    var loginTemplate = root.querySelector("[data-od-dl-login]");

    var accessCode = new URLSearchParams(window.location.search).get("code");

    function setStatus(html) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.innerHTML = html;
    }

    function hideStatus() {
      if (statusEl) statusEl.hidden = true;
    }

    function showTemplate(template) {
      hideStatus();
      if (template && ordersEl) {
        ordersEl.hidden = false;
        ordersEl.innerHTML = "";
        ordersEl.appendChild(template.content.cloneNode(true));
      }
    }

    function formatDate(iso) {
      if (!iso) return "";
      var date = new Date(iso);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    }

    function formatBadge(format) {
      var labels = {
        mp3: "MP3",
        flac: "FLAC",
        flac_upgrade: "FLAC",
        cd: "MP3"
      };
      return labels[format] || "";
    }

    function escapeText(value) {
      var div = document.createElement("div");
      div.textContent = value == null ? "" : String(value);
      return div.innerHTML;
    }

    function renderFileRow(order, file) {
      var expired = file.access && file.access.state !== "active";
      var exhausted = file.remaining <= 0;
      var titleParts = String(file.productTitle || file.fileName).split(" - ");
      var work = escapeText(titleParts[0]);
      var cast = titleParts.length > 1 ? escapeText(titleParts.slice(1).join(" - ")) : "";
      var title =
        '<span class="od-dl-file__work">' + work + "</span>" +
        (cast ? '<br><span class="od-dl-file__cast">' + cast + "</span>" : "");
      var art = file.productImageUrl
        ? '<img class="od-dl-file__art" src="' + escapeText(file.productImageUrl) + '" alt="" loading="lazy">'
        : '<span class="od-dl-file__art od-dl-file__art--empty"></span>';
      var part = file.partLabel ? '<span class="od-dl-file__part">' + escapeText(file.partLabel) + "</span>" : "";
      var badge = formatBadge(file.variantFormat);

      var action;
      if (expired) {
        action =
          '<div class="od-dl-file__locked">' +
          'Access expired — <a href="' + contactUrl + '">contact us</a> or ' +
          '<a href="' + membershipUrl + '">become a member</a> for open-ended downloads.' +
          "</div>";
      } else if (exhausted) {
        action =
          '<div class="od-dl-file__locked">' +
          'Download limit reached — <a href="' + contactUrl + '">contact us</a> to refresh access.' +
          "</div>";
      } else {
        action =
          '<button class="od-dl-btn" type="button" data-od-dl-download ' +
          'data-code="' + escapeText(order.accessCode) + '" data-file="' + escapeText(file.fileName) + '">' +
          "Download</button>" +
          '<span class="od-dl-file__remaining">' + file.remaining + " of " + file.maxDownloads + " downloads left</span>";
      }

      return (
        '<div class="od-dl-file" data-file-row="' + escapeText(order.accessCode + ":" + file.fileName) + '">' +
        art +
        '<div class="od-dl-file__info">' +
        '<span class="od-dl-file__title">' + title + "</span>" +
        '<span class="od-dl-file__tags">' +
        part +
        (badge ? '<span class="od-dl-file__badge">' + badge + "</span>" : "") +
        "</span>" +
        "</div>" +
        '<div class="od-dl-file__action">' + action + "</div>" +
        "</div>"
      );
    }

    function renderOrders(orders) {
      hideStatus();
      if (!ordersEl) return;
      ordersEl.hidden = false;
      ordersEl.innerHTML = orders
        .map(function (order) {
          var meta = [order.orderName, formatDate(order.orderCreatedAt)]
            .filter(Boolean)
            .join(" · ");
          return (
            '<section class="od-dl-order">' +
            '<h2 class="od-dl-order__title">' + escapeText(meta || "Order") + "</h2>" +
            '<div class="od-dl-order__files">' +
            order.files.map(function (file) {
              return renderFileRow(order, file);
            }).join("") +
            "</div>" +
            "</section>"
          );
        })
        .join("");
    }

    function handleDownloadClick(event) {
      var button = event.target.closest("[data-od-dl-download]");
      if (!button) return;

      var code = button.dataset.code;
      var file = button.dataset.file;
      button.disabled = true;
      button.textContent = "Preparing…";

      fetch(
        apiBase +
          "/downloads/file?redirect=0&code=" +
          encodeURIComponent(code) +
          "&file=" +
          encodeURIComponent(file)
      )
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result && result.ok && result.url) {
            var remainingEl = button.parentElement.querySelector(".od-dl-file__remaining");
            if (remainingEl) {
              remainingEl.textContent = result.remaining + " of 5 downloads left";
            }
            window.location.assign(result.url);
            button.textContent = "Download";
            button.disabled = false;
            return;
          }

          var message = "Something went wrong — please try again.";
          if (result && result.error === "download_limit_reached") {
            message = 'Download limit reached — <a href="' + contactUrl + '">contact us</a> to refresh access.';
          } else if (result && result.error === "access_expired") {
            message = 'Access expired — <a href="' + contactUrl + '">contact us</a> or <a href="' + membershipUrl + '">become a member</a>.';
          }
          button.parentElement.innerHTML = '<div class="od-dl-file__locked">' + message + "</div>";
        })
        .catch(function () {
          button.textContent = "Download";
          button.disabled = false;
          setStatus("<p>We couldn't start that download. Please check your connection and try again.</p>");
        });
    }

    function normalizeGuestManifest(manifest) {
      return [
        {
          orderName: manifest.order && manifest.order.orderName,
          orderCreatedAt: manifest.order && manifest.order.orderCreatedAt,
          accessCode: accessCode,
          files: manifest.files || []
        }
      ];
    }

    function loadGuest() {
      fetch(apiBase + "/downloads/manifest?code=" + encodeURIComponent(accessCode))
        .then(function (response) { return response.json(); })
        .then(function (manifest) {
          if (manifest && manifest.ok) {
            renderOrders(normalizeGuestManifest(manifest));
          } else {
            setStatus(
              "<p>We couldn't find downloads for this link. It may be incorrect — " +
                '<a href="' + contactUrl + '">contact us</a> and we\'ll help.</p>'
            );
          }
        })
        .catch(function () {
          setStatus("<p>We couldn't load your downloads. Please try again shortly.</p>");
        });
    }

    function loadLoggedIn() {
      fetch(portalEndpoint, { headers: { Accept: "application/json" } })
        .then(function (response) { return response.json(); })
        .then(function (manifest) {
          if (manifest && manifest.ok) {
            if (!manifest.orders || manifest.orders.length === 0) {
              showTemplate(emptyTemplate);
            } else {
              renderOrders(manifest.orders);
            }
          } else {
            setStatus(
              "<p>Downloads are temporarily unavailable. Please try again shortly or " +
                '<a href="' + contactUrl + '">contact us</a>.</p>'
            );
          }
        })
        .catch(function () {
          setStatus("<p>We couldn't load your downloads. Please try again shortly.</p>");
        });
    }

    root.addEventListener("click", handleDownloadClick);

    if (accessCode) {
      loadGuest();
    } else if (loggedIn) {
      loadLoggedIn();
    } else {
      showTemplate(loginTemplate);
    }
  }

  var bootScheduled = false;
  function scheduleBoot() {
    if (bootScheduled) return;
    bootScheduled = true;
    window.requestAnimationFrame(function () {
      bootScheduled = false;
      boot();
    });
  }

  if (!window.__odDownloadsPortalWired) {
    window.__odDownloadsPortalWired = true;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }

    [
      "od:after-swap",
      "od:main-content-replaced",
      "shopify:section:load",
      "turbo:load",
      "turbolinks:load",
      "pjax:complete",
      "swup:contentReplaced",
      "barba:after"
    ].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleBoot);
    });

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length > 0) {
          scheduleBoot();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } else {
    boot();
  }
})();
